import axios from 'axios'
import { DateTime } from 'luxon'
import React, { useEffect, useState } from 'react'
import { HiDotsVertical, HiInformationCircle } from 'react-icons/hi'
import { ColumnsTable, IFinance } from 'safe'
import AdvancedIncomeForm from '../../components/Display/AdvancedIncomeForm'
import FloatingForm from '../../components/Display/FloatingForm'
import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { HeaderProps } from '../../components/Layout/Header'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import {
  formatPipe,
  getDenomination,
  getYearMonthAndDay,
  transformDate,
} from '../../utils/utils'
import WatchPurchase from '../Purchases/Purchase/WatchPurchase'
import WatchSale from '../Sells/WatchSale'
import IncomeForm from './IncomeForm'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'

const server = process.env.REACT_APP_SERVER_URL

const Outflow: React.FC<OutflowProps> = ({ setHeaderActions }) => {
  const [outflowInfo, setOutflowInfo] = useState<{
    outflow: IFinance[]
    numberOfPages: number
    loading: boolean
    currentPage: number
  }>({ outflow: [], numberOfPages: 0, loading: false, currentPage: 0 })

  const [menuVisible, setMenuVisible] = useState<any>()

  const [outflowToDelete, setOutflowToDelete] = useState<string | null>(null)

  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)

  const [userConfig] = useLocalStorageState('user-config')

  const [modalSearch, setModalSearch] = useState<boolean>(false)

  const [searchParams, setSearchParams] = useState<string[]>([])

  const [showModalAdd, setShowModalAdd] = useState<boolean>(false)

  const [selectedOutflow, setSelectedOutflow] = useState<any | null>(null)

  const [elementToView, setElementToView] = useState<{
    type: 'SALE' | 'PURCHASE'
    info: any
  } | null>(null)

  const { outflow, numberOfPages, loading, currentPage } = outflowInfo

  const { addAlert } = useSnackBars()

  const [fastSearch, setFastSearch] = useState<string>('')

  const userRole = useSelector(
    (state: RootState) => state.auth.user['custom:user_role']
  )

  const columns: ColumnsTable[] = [
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {transformDate(record?.date)}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {`${getDenomination(record?.currency?.id)} ${formatPipe(
            record.amount
          )}`}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Cuenta',
      dataIndex: 'account.description',
      key: 'account.description',
      // render: (id: number, record: any) => (
      //   <ColumnItemWrapper
      //     subElement="paragraph"
      //     subElementStyle="dark:text-white text-black"
      //   >
      //     {record?.account?.description}
      //   </ColumnItemWrapper>
      // ),
    },
    {
      title: 'Referencia',
      dataIndex: 'reference',
      key: 'reference',
    },
    {
      title: 'Concepto',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Tipo',
      dataIndex: 'description',
      key: 'description',
      render: (id: number, record: any) => {
        let obj = {
          DIVIDEND_PAYMENT : "PAGO DE DIVIDENDOS",
          PAYROLL : "NÓMINA",
          INSTALLMENT : "PAGO DE CUOTA CRÉDITO COMERCIAL",
          PURCHASE : "COMPRA",
          REFUND : "REEMBOLSO",
          OTHER : "OTRO",
          BANK_LOAN_INSTALLMENT : "PAGO CUOTA CRÉDITO BANCARIO",
          BANK_LOAN_INTEREST : "PAGO INTERÉS CRÉDITO BANCARIO",
          LOAN : "PRÉSTAMO COMERCIAL",
          RENT : "ALQUILER",
          MARKETING : "PUBLICIDAD",
          OFFICE_EXPENSES : "GASTOS DE OFICINA",
          SERVICES : "SERVICIOS",
          IVA_PAYMENT : "PAGO IVA",
          IGTF_PAYMENT : "PAGO IGTF",
          ISLR_PAYMENT : "PAGO ISLR",
          CITY_TAXES_PAYMENT : "PAGO IMPUESTOS MUNICIPALES",
          OTHER_TAXES_PAYMENT : "PAGO OTROS IMPUESTOS",
          BANK_COMMISSION : "COMISIÓN BANCARIA",
          CUSTOM : "AVANZADO",
          PROPERTY_INVESTMENT: 'COMPRA EDIFICACIONES'
        }

        return (
          <ColumnItemWrapper>
            <p>{obj[record.type] || ''}</p>
          </ColumnItemWrapper>
        )
      },
    },
    // {
    //   title: 'Tipo de iva',
    //   dataIndex: 'ivaType',
    //   key: 'ivaType',
    //   render: (id: number, record: any) => {
    //     let objTransform = {
    //       GENERAL: 'GENERAL',
    //       REDUCED: 'REDUCIDO',
    //       EXEMPT: 'EXENTO',
    //       SUMPTUARY: 'SUNTUARIO',
    //     }
    //     return (
    //       <ColumnItemWrapper subElementStyle="dark:text-white text-black">
    //         <p>{objTransform[record.ivaType]}</p>
    //       </ColumnItemWrapper>
    //     )
    //   },
    // },
    {
      title: 'Emisor',
      dataIndex: 'provider.businessName',
      key: 'provider.businessName',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          {record?.client?.name || record?.provider?.businessName || record?.otherPayer}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Usuario',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, record: any) => (
        <ColumnItemWrapper floatingMenu>
          {/* <div className="text-gray-500 relative"> */}
          <FloatingMenu
            visible={menuVisible === id}
            onClose={() => {
              setMenuVisible(-1)
            }}
            options={{
              onDelete: () => {
                setOutflowToDelete(record.id)
                setShowConfirmModal(true)
              },
              watchOutflow: async () => {
                try {
                  let response = await axios.get(
                    `${server}/outflow?id=${record?.id}`
                  )
                  setSelectedOutflow(response.data.outflow)
                } catch (err) {
                  addAlert({
                    message: 'Error al obtener ingreso',
                    status: 'error',
                  })
                }
              },
            }}
          >
            <HiDotsVertical
              className="cursor-pointer dark:text-white text-primaryGray-400"
              onClick={() => {
                setMenuVisible(id)
                // setEdit(record)
                // setModal(true)
              }}
            />
          </FloatingMenu>
        </ColumnItemWrapper>
      ),
    },
  ]

  const getOutflow = async (
    querySearch: string[] = searchParams,
    page: number = currentPage,
    fastParam = fastSearch
  ): Promise<void> => {
    setSearchParams(querySearch)
    setOutflowInfo((prevState) => ({
      ...prevState,
      currentPage,
      loading: true,
    }))
    setFastSearch(fastParam)
    let paginationParams: string[] = [
      `pageNumber=${page + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]

    let newParams = [...querySearch]

    if (fastParam) {
      newParams.push(`fastSearch=${fastParam}`)
    }


    let response = await axios.get<{
      outflows: IFinance[]
      numberOfPages: string
    }>(`${server}/outflow?${[...paginationParams, ...newParams].join('&')}`)

    setOutflowInfo((prevState) => ({
      ...prevState,
      outflow: response.data.outflows,
      loading: false,
      numberOfPages: +response.data.numberOfPages || 1,
    }))
  }

  useEffect(() => {
    if (userRole === "seniat") {
      setHeaderActions({
      advancedSearch: (value) => {
        if (typeof value === 'boolean') {
          setModalSearch(true)
          return
        }
        getOutflow(searchParams, currentPage, value)
      },
      cleanFilters: {
        sort: () => {},
        search: () => {
          getOutflow([], 0)
        },
        isSearch: Boolean(searchParams.length > 0),
      },
    })
    } else {
      setHeaderActions({
        addAction: () => {
          setShowModalAdd(true)
        },
      advancedSearch: (value) => {
        if (typeof value === 'boolean') {
          setModalSearch(true)
          return
        }
        getOutflow(searchParams, currentPage, value)
      },
      cleanFilters: {
        sort: () => {},
        search: () => {
          getOutflow([], 0)
        },
        isSearch: Boolean(searchParams.length > 0),
      },
    })
    }
    
    return () => {
      setHeaderActions(null)
    }
  }, [setHeaderActions, searchParams, currentPage, userRole])

  useEffect(() => {
    getOutflow()
  }, [])

  return (
    <>
      <Table
        columns={userRole === "seniat" ? columns.slice(0, -1) : columns}
        data={outflow}
        pages={numberOfPages}
        loading={loading}
        pageSelected={currentPage}
        setPageSelected={(page) => getOutflow(searchParams, page)}
      />

      <FloatingForm
        visible={modalSearch}
        onClose={() => setModalSearch(false)}
        topClass="top-20"
        rightClass="right-10"
        containerClass="w-2/6"
      >
        <AdvancedIncomeForm
          onSubmit={async (values) => {
            console.log('values...', values)
            if (values.isDateSelected) {
              const [yearFrom, monthFrom, dayFrom] = getYearMonthAndDay(
                values.fromDate
              )
              const [yearTo, monthTo, dayTo] = getYearMonthAndDay(values.toDate)
              let from = new Date(yearFrom, monthFrom, dayFrom)
              let to = new Date(yearTo, monthTo, dayTo + 1)
  
              let dateFrom = DateTime.fromISO(from.toISOString()).toISODate()
              let datePrueba = DateTime.fromISO(to.toISOString()).toISODate()
              console.log('date prueba...', datePrueba)
  
              // let newTo = to.toISOString()
              // console.log("NEW", newTo.replace(/T.+/, '').replace(/\-/g, "/"))
              // console.log("TO", to.toLocaleDateString('en-US'))
              // let [year, month, day] = newTo.replace(/T.+/, '').replace(/\-/g, "/").split("/")
              // const [yearToNew, monthToNew, dayToNew] = getYearMonthAndDay(`${day}/${month}/${year}`)
  
              values.fromDate = dateFrom
  
              values.toDate = datePrueba
            }

            if (!values.isDateSelected) {
              delete values.fromDate
              delete values.toDate
              delete values.isDateSelected
            }

            let params = Object.keys(values).reduce((a, b) => {
              if (values[b]) {
                return [...a, `${b}=${values[b]}`]
              }
              return a
            }, [] as any)
            await getOutflow(params, 0)
            setModalSearch(false)
          }}
          onClose={() => setModalSearch(false)}
        />
      </FloatingForm>

      <Modal
        display={showModalAdd}
        onClose={() => setShowModalAdd(false)}
        xlClasses="w-[650px]"
      >
        <IncomeForm
          type="OUTFLOW"
          onClose={() => setShowModalAdd(false)}
          onSubmit={async (values) => {
            addAlert({
              message: 'Creando egreso',
              status: 'loading',
            })
            try {
              await axios.post(`${server}/outflow`, values)
              await getOutflow([], 0)
              setShowModalAdd(false)
              addAlert({
                message: 'Egreso creado satisfactoriamente',
                status: 'success',
              })
            } catch (err) {
              addAlert({
                message: 'Error al crear egreso',
                status: 'error',
              })
            }
          }}
        />
      </Modal>

      <ModalConfirm
        title={'¿Está seguro que desea eliminar este egreso?'}
        displayConfirmModal={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        onConfirm={async () => {
          addAlert({
            message: 'Eliminando egreso',
            status: 'loading',
          })
          try {
            await axios.delete(`${server}/outflow?id=${outflowToDelete}`)
            await getOutflow([], 0)
            addAlert({
              message: 'Egreso eliminado satisfactoriamente',
              status: 'success',
            })
          } catch (err) {
            addAlert({
              message: 'Error al eliminar egreso',
              status: 'error',
            })
          } finally {
            setShowConfirmModal(false)
          }
        }}
      />

      <Modal
        display={!!selectedOutflow}
        onClose={() => setSelectedOutflow(null)}
      >
<h2 className="col-span-12 mb-2 text-primary-900 font-bold mb-3">
        Info de egreso
      </h2>
        <div className="grid grid-cols-12 gap-6">
          <div
            className="col-span-6 p-5 lg:col-span-12"
            style={{ boxShadow: '0px 3px 4px 3px #cccccc40' }}
          >
            <div className="flex flex-row mb-2">
              <label className="font-bold">Descripción:</label>
              <label className="ml-2 truncate">
                {selectedOutflow?.description}
              </label>
            </div>

            <div className="flex flex-row">
              <label className="font-bold">Usuario:</label>
              <label className="ml-2 truncate">
                {selectedOutflow?.username}
              </label>
            </div>
          </div>

          <div
            className="col-span-6 p-5 lg:col-span-12"
            style={{ boxShadow: '0px 3px 4px 3px #cccccc40' }}
          >
            <div className="flex flex-row mb-2">
              <label className="font-bold">Fecha:</label>
              <label className="ml-2 truncate">
                {DateTime.fromISO(selectedOutflow?.date).toLocaleString({
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })}
              </label>
            </div>

            <div className="flex flex-row mb-2">
              <label className="font-bold">Monto:</label>
              <label className="ml-2 truncate">
                {getDenomination(selectedOutflow?.currency?.id)}{' '}
                {formatPipe(selectedOutflow?.amount)}
              </label>
            </div>

            <div className="flex flex-row">
              <label className="font-bold">Referencia:</label>
              <label className="ml-2 truncate">
                {selectedOutflow?.reference}
              </label>
            </div>
          </div>

          {selectedOutflow?.purchases?.length > 0 && (
            <div className="col-span-12">
              <div className="flex flex-row">
                <div className="text-primary">
                  <HiInformationCircle size={25} />
                </div>
                <label className="ml-3">
                  Este egreso está asociado a las siguientes compras:
                </label>
              </div>
              <div className="col-span-12 flex flex-row flex-wrap">
                {selectedOutflow?.purchases?.map((purchase) => (
                  <div
                    style={{ flexBasis: '32%' }}
                    className="mt-3 text-center"
                    key={purchase?.id}
                    onClick={async () => {
                      // let id =
                      //       selectedIncome?.sales.length > 0
                      //         ? selectedIncome?.sales[0]?.id
                      //         : ''
                      //     let type: 'SALE' | 'PURCHASE' =
                      // selectedIncome?.sales.length > 0 ? 'SALE' : 'PURCHASE'
                      // let obj : any = {
                      //   type: selectedIncome?.sales.length > 0 ? 'SALE' : 'PURCHASE',
                      //   info: selectedIncome?.sales.length > 0 ? selectedIncome?.sales[0]?.id : ""
                      // }
                      let response = await axios.get(
                        `${server}/purchase?id=${purchase.id}`
                      )
                      setElementToView(response?.data?.purchase)
                    }}
                  >
                    <label className="text-primary cursor-pointer ml-9">
                      {' '}
                      {purchase?.billCode
                        ? `Compra de factura Nmo ${purchase?.billCode}`
                        : 'Compra sin factura'}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* {selectedOutflow?.sales?.length > 0 && (
            <div className="col-span-12">
              <div className="flex flex-row ml-3">
                <div className="flex items-center text-primary">
                  <HiInformationCircle size={25} />
                </div>

                <div className="flex flex-col ml-3">
                  <label>
                    Este ingreso está asociado a una{' '}
                    {selectedOutflow?.sales.length > 0 ? 'venta' : ''}
                  </label>
                  <label
                    className="text-primary cursor-pointer"
                    onClick={async () => {
                      let id =
                        selectedOutflow?.sales.length > 0
                          ? selectedOutflow?.sales[0]?.id
                          : ''
                      let type: 'SALE' | 'PURCHASE' =
                        selectedOutflow?.sales.length > 0 ? 'SALE' : 'PURCHASE'
                      // let obj : any = {
                      //   type: selectedOutflow?.sales.length > 0 ? 'SALE' : 'PURCHASE',
                      //   info: selectedOutflow?.sales.length > 0 ? selectedOutflow?.sales[0]?.id : ""
                      // }
                      let response = await axios.get(
                        `${server}/${
                          type === 'SALE' ? 'sale' : 'purchase'
                        }?id=${id}`
                      )
                      setElementToView({
                        type,
                        info: response?.data?.sale || response?.data?.purchase,
                      })
                    }}
                  >
                    Ver {selectedOutflow?.sales.length > 0 ? 'venta' : ''}.
                  </label>
                </div>
              </div>

              <div className="h-px dark:bg-primaryGray-300 bg-primaryGray-300 col-span-12 mt-2"></div>
            </div>
          )} */}

          <div
            className="col-span-6 p-5 lg:col-span-12"
            style={{ boxShadow: '0px 3px 4px 3px #cccccc40' }}
          >
            <div className="flex flex-row mb-2">
              <label className="font-bold">Cliente:</label>
              <label className="ml-2 truncate">
                {selectedOutflow?.payer?.client?.name ||
                  selectedOutflow?.payer?.provider?.businessname ||
                  selectedOutflow?.payer?.other}
              </label>
            </div>

            <div className="flex flex-row">
              <label className="font-bold">Documento:</label>
              <label className="ml-2 truncate">
                {!selectedOutflow?.payer?.other &&
                  `${
                    selectedOutflow?.payer?.client?.documenttype ||
                    selectedOutflow?.payer?.provider?.documenttype
                  }-${
                    selectedOutflow?.payer?.client?.document ||
                    selectedOutflow?.payer?.provider?.document
                  }`}
              </label>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isFullHeight={true}
        xlClasses="xl:w-10/12 xl:h-5/6"
        innerStyle={{ height: '95%' }}
        display={!!elementToView}
        onClose={() => setElementToView(null)}
      >
        <WatchPurchase purchase={elementToView} />
      </Modal>

    </>
  )
}

interface OutflowProps {
  setHeaderActions: React.Dispatch<
    React.SetStateAction<HeaderProps['headerActions'] | null | undefined>
  >
}

export default Outflow
